import { defineComponent, ref, computed, onMounted } from 'vue';
import sys from '../../system';
import { framework } from '@truckdown/jsclient/apis';


import {
    solid
} from '@truckdown/jsclient/icons';

sys.fontLibrary.add(solid.faCircleXmark);

interface IService {
    name: string,
    url: string
}

var getServices = function (): IService[] {
    return Array.from(sys.framework.context.services)
        .map((v) => {
            return {
                name: v[0],
                url: v[1].url
            } as IService;
        });
};

export default defineComponent({
    name: 'context-info',
    props: { },
    setup: function (props, context) {
        const userContext = ref<framework.IUserContext>(sys.framework.context);

        const services = ref(getServices());
        const userSettings = ref<[string, string][]>(
            Array.from(sys.framework.context.settings));

        function close(ev: Event) {
            context.emit('close');
        }

        return {
            userContext,
            userSettings,
            services,
            close
        };
    }
});
